import Console from '#helpers/console'

export default function (state, payload) {
  const errorMessage = payload.errorMessage || undefined
  Console().error(payload.error)
  return {...state, error: payload.error, errorMessage}
}
